import { of as observableOf, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
//import './rxjs/add/operator/of';

@Injectable()
export class HrTranslateService {
  public instant(key: string): string {
    return this.translateService.instant(key);
  }

  public instantLabel(key: string) {
    return this.translateService.instant(`label:${key}`);
  }

  public instantMessage(key: string) {
    return this.translateService.instant(`message:${key}`);
  }

  public instantText(key: string) {
    return this.translateService.instant(`text:${key}`);
  }

  //public get(key: string): Observable<string> {

  //    return Observable.of(`${key}-TODO`);
  //}

  public getTranslation(lang: string): Observable<any> {
    return observableOf({}); //TODO
  }

  public init(config: { defaultLang: string; useLang: string }) {
    //TODO
    this.translateService.setDefaultLang(config.defaultLang);
    return this.translateService.use(config.useLang);
  }

  constructor(private translateService: TranslateService) {}
}
